export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_09-acee5164a8c62d4b055936b0d41d4130.jpg";